import { Link } from 'wouter';
import { take } from '@immutabl3/utils';
import { Spinner } from '../spinner';
import { useSearch } from './search.hooks';
import { useUsers } from '../../query';
import styles from './search.module.css';

export const Search = () => {
  const {
    isError,
    isLoading,
    data: users,
  } = useUsers();

  const {
    activeIndex,
    value,
    results,
    onChange,
    onKeyDown,
  } = useSearch(users ?? []);
  
  if (isError) return null;

  return (
    <form
      className={ styles.search }
      data-state={ isError ? 'error' : isLoading ? 'loading' : 'ready' }
      onSubmit={ e => {
        e.preventDefault();
        e.stopPropagation();
      } }
    >
      { isLoading && <Spinner /> }
      
      <input
        type="text"
        placeholder="Search..."
        value={ value }
        onChange={ onChange }
        onKeyDown={ onKeyDown }
      />

      { !!results.length && (
        <ol>
          { take(results, 5).map((result, idx) => {
            return (
              <li key={ idx }>
                <Link
                  to={ `/${result.name}` }
                  data-active={ idx === activeIndex }
                >
                  <span>
                    { result.name }
                  </span>
                </Link>
              </li>
            );
          }) }
        </ol>
      ) }
    </form>
  );
};